import { render, staticRenderFns } from "./PlayInfo.vue?vue&type=template&id=42951586&scoped=true&"
import script from "./PlayInfo.vue?vue&type=script&lang=js&"
export * from "./PlayInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlayInfo.vue?vue&type=style&index=0&id=42951586&prod&scoped=true&lang=scss&"
import style1 from "./PlayInfo.vue?vue&type=style&index=1&id=42951586&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42951586",
  null
  
)

export default component.exports